<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import { getMethod, add, del, update, getDetails } from "@/api/system/method";

import cTable from "@/base/common/index";
export default {
  name: "method",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getMethod,
        getDetails,
        del,
        add,
        update
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              method_name: [
                {
                  required: true,
                  message: "name cannot be empty",
                  trigger: "blur"
                },
                {
                  type: "string",
                  max: 55,
                  message: "Please enter maximum length 55",
                  trigger: "blur"
                }
              ],
              method_code: [
                {
                  required: true,
                  message: "code cannot be empty",
                  trigger: "blur"
                },
                {
                  type: "string",
                  max: 1,
                  message: "Please enter maximum length 1",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { method_name: 24 },
            { method_name_en: 24 },
            { method_code: 24 }
          ],
          fields: [
            {
              name: () => this.$t("method_name"),
              key: "method_name",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("method_name");
              }
            },
            {
              name: () => this.$t("method_name") + this.$t("English"),
              key: "method_name_en",
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("method_name") + this.$t("English")
                );
              }
            },
            {
              name: () => this.$t("method_code"),
              key: "method_code",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("method_code");
              }
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
          // {
          //   key: "ClientId",
          //   type: "select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" }
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 146
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("method_name"),
          children: [
            {
              name: () => this.$t("Chinese"),
              key: "method_name",
              align: "center",
              minWidth: 200
            },
            {
              name: () => this.$t("English"),
              key: "method_name_en",
              align: "center",
              minWidth: 200
            }
          ]
        },

        {
          name: () => this.$t("method_code"),
          align: "center",
          key: "method_code",
          minWidth: 160,
          tooltip: true
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 147
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 148
              // bind: {
              //   type: "error"
              // }
            }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
